import callAPI from '../../../API/callSecureAPI'
import endpoints from '../../../API/endpoints'
import { useAuth0 } from '../../../contexts/auth0-context'
import { useMutation } from 'react-query'
import { useInvalidateGetValueNarrativesQuery } from './useInvalidateGetValueNarrativesQuery'

export const useReorderValueNarrativesMutation = () => {
    const { getTokenSilently } = useAuth0()

    const reorderValueNarratives = async (orderedNarrativeIds: string[]) => {
        try {
            const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            const { url, method } = endpoints.reorderValueNarratives
            return await callAPI(url, method, token, orderedNarrativeIds)
        } catch (e) {
            console.log(e)
        }
    }

    const { invalidateGetValueNarrativesQuery } = useInvalidateGetValueNarrativesQuery()

    return useMutation(reorderValueNarratives, {
        onSuccess: async () => {
            await invalidateGetValueNarrativesQuery()
        },
    })
}
